// routes/components/InvalidTokenMessage.jsx
import { useTranslation } from 'react-i18next'
import mySkyProFooterImage from '../../assets/imagesNew/my-sky-pro-footer-OSR.png'
import { ERROR_TYPES } from '../../infra/constants/ErrorTypes'
import '../../pages/OrderSupplierReception/styles.scss'

export const InvalidTokenMessage = ({ type = ERROR_TYPES.INVALID, onRetry }) => {
  const { t } = useTranslation()
  const year = new Date().getFullYear()

  // Mapeamento de chaves i18n por tipo de erro
  const titleKey =
    type === ERROR_TYPES.EXPIRED
      ? 'PAGE_LINK_EXPIRED'
      : type === ERROR_TYPES.NETWORK
        ? 'PAGE_LINK_NETWORK_ERROR'
        : 'PAGE_LINK_INVALID'

  const descKey =
    type === ERROR_TYPES.EXPIRED
      ? 'PAGE_LINK_EXPIRED_DESCRIPTION'
      : type === ERROR_TYPES.NETWORK
        ? 'PAGE_LINK_NETWORK_ERROR_DESCRIPTION'
        : 'PAGE_LINK_INVALID_DESCRIPTION'

  const showRetry = type === ERROR_TYPES.NETWORK

  return (
    <div className="container">
      <div className="error">
        <h2>{t(titleKey)}</h2>
        <p>{t(descKey)}</p>

        {showRetry && (
          <div style={{ marginTop: 16 }}>
            <button
              type="button"
              className="submitBtn"
              onClick={onRetry || (() => window.location.reload())}
            >
              {t('RETRY')}
            </button>
          </div>
        )}
      </div>

      <div className='logo'>
        <p>
          <a href="https://backoffice.wearskypro.com" title="mySKYPRO Portal">
            <img src={mySkyProFooterImage} alt="mySKYPRO" />
          </a>
        </p>
        <p>{t('ALL_RIGHTS_RESERVED', { year })}</p>
      </div>
    </div>
  )
}

export default InvalidTokenMessage